import { Injectable } from '@angular/core';

import { BaseProductApi } from '../../BaseProductApi';
import { IDeltacastSiteMap } from '../../../../model/product/tena/deltacast/IDeltacastSiteMap';

@Injectable()
export class DeltacastSiteMapApi extends BaseProductApi<IDeltacastSiteMap> {
    protected getBaseUrl() {
        return super.getBaseUrl() + 'hmsglobalsitemap/deltacast';
    }
}
